import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useSyncCodeTables = () => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async () => {
      if (!tenantVal) throw new Error("Tenant not found");
      
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/codetable/sync`
      );
      return response.data;
    },
    onSuccess: (data) => {
      toast.success(`Successfully synced ${data} code tables from Healthlink`);
    },
    onError: (error) => {
      toast.error(`Failed to sync code tables: ${error.message}`);
    }
  });
};